import {
  GET_CATEGORY_BY_ID_FOR_HIRE,
  GET_FILTERD_HIRE_EXPERT,
  GET_FOLLOW_PROFILE,
  GET_INDUSTRY_CATEGORY_FOR_HIRE,
  GET_USER_FOR_HIRE,
  GET_USER_PROFILE,
} from "../constants/index";

export const hire = (
  state = {
    getusesforhire: [],
    getuserprofile: {},
    getindustrucatagoryforhire: [],
    getcatagorybyidforhire: [],
    getfilterdhiredexpert: [],
  },
  action
) => {
  switch (action.type) {
    case GET_USER_FOR_HIRE:
      return { ...state, getusesforhire: action.getusesforhire };
    case GET_FILTERD_HIRE_EXPERT:
      return { ...state, getfilterdhiredexpert: action.getfilterdhiredexpert };
    case GET_USER_PROFILE:
      return { ...state, getuserprofile: action.getuserprofile };
    case GET_FOLLOW_PROFILE:
      return { ...state, getfollowprofile: action.getfollowprofile };
    case GET_INDUSTRY_CATEGORY_FOR_HIRE:
      return {
        ...state,
        getindustrucatagoryforhire: action.getindustrucatagoryforhire,
      };
    case GET_CATEGORY_BY_ID_FOR_HIRE:
      return {
        ...state,
        getcatagorybyidforhire: action.getcatagorybyidforhire,
      };
    default:
      return state;
  }
};
